import { useMemo, useState } from "react";

import { useNavigate } from "react-router-dom";

import { Button } from "@mui/material";
import { PageContainer } from "@/features/ui";

import {
  DEFAULT_VALUES,
  JournalVoucherForm,
} from "@/features/journal-vouchers";
import { apiOutletClient, getErrorMessage } from "@/features/shared";
import { useSnackbar } from "@/features/ui";

export const CreateJournalVoucher = () => {
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Set default outlet from localStorage (captured once at component mount)
  const defaultValues = useMemo(() => {
    const outlet = JSON.parse(localStorage.getItem("outlet") || "null");
    return {
      ...DEFAULT_VALUES,
      outlet,
    };
  }, []);

  const handleSubmit = async (data) => {
    try {
      setIsSubmitting(true);

      const { outletId, ...payload } = data;

      await apiOutletClient.post("journal-vouchers", payload, {
        headers: {
          "Outlet-Id": outletId,
        },
      });

      showSnackbar("Jurnal umum berhasil dibuat", "success");
      navigate(-1);
    } catch (error) {
      console.error("Failed to create journal voucher:", error);
      showSnackbar(
        getErrorMessage(error, "Gagal membuat jurnal") ||
          "Gagal membuat jurnal umum"
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <PageContainer
      maxWidth="xl"
      title="Buat Jurnal Umum"
      breadcrumbs={[
        { title: "Jurnal Umum", path: "/general-ledger/journal-vouchers" },
        { title: "Buat" },
      ]}
    >
      <JournalVoucherForm
        defaultValues={defaultValues}
        onSubmit={handleSubmit}
        renderActionButton={({ isBalanced }) => (
          <Button
            type="submit"
            variant="contained"
            disabled={isSubmitting || !isBalanced}
            size="large"
          >
            {isSubmitting ? "Menyimpan..." : "Simpan"}
          </Button>
        )}
      />
    </PageContainer>
  );
};
